import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
const SubMenu = Menu.SubMenu;

@inject('store')
@observer
export class MainMenu extends Component {
    render() {
        let bots = Object.values(this.props.store.botStore.bots);
        bots = [...bots, ...this.props.store.botConfigStore.configurations];

        return (
            <Menu
                mode="horizontal"
                defaultSelectedKeys={['1']}
                style={{ lineHeight: '64px', background: 'none', border: 'none', width: '80%' }}
            >
                <SubMenu
                    key="1"
                    title={
                        <Link to={'/a/bots'}>
                            <span>Bots</span>
                        </Link>
                    }
                >
                    {bots.map(bot => {
                        return (
                            <Menu.Item key={bot._id || bot.id}>
                                <Link
                                    to={`/a/${bot.type || 'bot'}/${bot._id || bot.id}/${
                                        bot.type === 'odyssey' || bot.type === 'mako'
                                            ? 'trade'
                                            : 'positions'
                                    }`}
                                >
                                    <span>
                                        <img
                                            height="18px"
                                            src={`/exchanges/${bot.exchange}.png`}
                                            alt={`${bot.exchange} logo`}
                                        />{' '}
                                        {bot.name}
                                    </span>
                                </Link>
                            </Menu.Item>
                        );
                    })}
                </SubMenu>
                <Menu.Item key="2">
                    <Link to={'/a/strategies/standard'}>
                        <span>Strategies</span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="3">
                    <Link to={'/a/subscriptions'}>
                        <span>Subscriptions</span>
                    </Link>
                </Menu.Item>
                {this.props.store.userStore.currentUser.copy_trader_token ? (
                    <Menu.Item key="6">
                        <Link to={'/a/copytrading'}>
                            <span>Copy Trading</span>
                        </Link>
                    </Menu.Item>
                ) : null}
                <Menu.Item key="4">
                    <Link to={'/a/strat-center'}>
                        <span>Strategy Center</span>
                    </Link>
                </Menu.Item>
                <SubMenu key="5" title="My Account">
                    <Menu.Item>
                        <Link to={'/a/my-account'}>
                            <span>Account Settings</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item>
                        <Link to={'/a/getting-started'}>
                            <span>Getting Started</span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={'https://apextrader.zendesk.com/hc/en-us'}
                        >
                            User Guide
                        </a>
                    </Menu.Item>
                    <Menu.Item>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={'https://forum.apextrader.io'}
                        >
                            Forum
                        </a>
                    </Menu.Item>
                    <Menu.Item>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={'https://discordapp.com/invite/hWRMk3m'}
                        >
                            Discord
                        </a>
                    </Menu.Item>
                    <Menu.Item>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={'https://apextrader.firstpromoter.com/ '}
                        >
                            Affiliate Program
                        </a>
                    </Menu.Item>

                    <Menu.Item>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => this.props.store.userStore.logout()}
                        >
                            Logout
                        </a>
                    </Menu.Item>
                </SubMenu>
            </Menu>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/MainMenu.js